// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"e75c6cdf","239":"ff47cc1e","453":"a074a449","455":"49b04711","977":"f0e63441"}[chunkId] + ".chunk.js";
};